import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../../../config';
import { RemarkItem } from '../../../types';

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  masterPoolNumber: number;
};

const apiClientConfig: ApiClientConfig = {
  timeout: config.validationReviewInventoryApi.requestTimeout
};

const timeout: number = config.validationReviewInventoryApi.requestTimeout;

const poolInventoryDetailUrl: string =
  config.validationMasterPoolAPi.urls.masterPoolInventoryDetail;

export const getMasterPoolHistoricalRemarks = async ({
  authenticationContext,
  masterPoolNumber
}: RequestProps): Promise<RemarkItem[]> => {
  try {
    const requestQuery = `${poolInventoryDetailUrl}/${masterPoolNumber}/remarks`;

    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      requestQuery,
      { timeout }
    );

    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error('Error while getting remarks');
  }
};
